<template>
  <div />
</template>
<script>
import utils from '@/utils'

export default defineComponent({
  name: 'JsonLdProduct',
  props: {
    product: {
      type: Object,
      required: true,
    },
    comments: {
      type: Object,
      required: true,
    },
  },
  jsonld() {
    const productAvailable = this.product.onboard ? 'http://schema.org/InStock' : 'https://schema.org/OutOfStock'
    const jsonld = {
      '@context': 'http://schema.org',
      '@type': 'Product',
      name: this.product.product_name,
      sku: this.product.pid,
      brand: {
        '@type': 'Brand',
        name: this.product.branch_name,
      },
      offers: {
        '@type': 'Offer',
        url: this.$config.public.BASE_URL + `/products/${this.product.pid}`,
        availability: productAvailable,
        priceCurrency: this.product.symbol_code,
        price: this.product.discount,
        priceValidUntil: this.$dayjs().add(6, 'months').format('YYYY-MM-DD'),
        seller: {
          '@type': 'Organization',
          name: 'FunNow',
        },
      },
    }
    let images = []
    if (this.product.cover_image !== '') {
      images.push(`${utils.CDN}${utils.imagePath(this.product.cover_image)}`)
    }
    if (this.product.images?.length > 0) {
      images = images.concat(
        this.product.images.map(image => {
          return `${utils.CDN}${utils.imagePath(this.image)}`
        })
      )
    }
    if (images.length > 0) {
      jsonld.image = images
    }
    if (this.product.description) {
      jsonld.description = utils.removeNewLine(this.product.description)
    }
    if (this.comments.total_count > 0) {
      jsonld.aggregateRating = {
        '@type': 'AggregateRating',
        ratingValue: this.comments.avg_rating,
        ratingCount: this.comments.total_count,
      }
    }
    if (this.comments.comment && this.comments.comment.length > 0) {
      jsonld.review = this.comments.comment.map(comment => {
        return {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: comment.rated_by,
          },
          datePublished: this.$dayjs(comment.rate_time).format('YYYY/MM/DD'),
          description: utils.removeNewLine(comment.rating_description),
          reviewRating: {
            '@type': 'Rating',
            bestRating: 5,
            ratingValue: comment.rating,
            worstRating: 1,
          },
        }
      })
    }

    return jsonld
  },
})
</script>
